import { User, UserSession, UserCommunity, UserBlock } from "@/services/auth/types";
import { defineStore } from "pinia";

export const useAuthStore = defineStore("auth", {
    state: () => {
        const localStorageUser = localStorage.getItem("user")
        const localStorageUserSession = localStorage.getItem("userSession")
        const localStorageUserCommunity = localStorage.getItem("userCommunity")
        const localStorageUserBlock = localStorage.getItem("userBlock")

        let user: User | null = null
        let userSession: UserSession | null = null;
        let userCommunity: UserCommunity | null = null;
        let userBlock: UserBlock | null = null;

        if (localStorageUser) {
            user = JSON.parse(localStorageUser)
        }
        if (localStorageUserSession) {
            userSession = JSON.parse(localStorageUserSession)
        }

        if (localStorageUserCommunity) {
            userCommunity = JSON.parse(localStorageUserCommunity)
        }
        if (localStorageUserBlock) {
            userBlock = JSON.parse(localStorageUserBlock)
        }

        return {
            token: localStorage.getItem("token"),
            user: user,
            userSession: userSession,
            userCommunity: userCommunity,
            userBlock: userBlock
        }
    },

    actions: {
        setToken(token: string) {
            this.token = token
            localStorage.setItem("token", token)
        },

        setUser(user: User) {
            this.user = user
            localStorage.setItem("user", JSON.stringify(user))
        },

        setUserSession(userSession: UserSession) {
            this.userSession = userSession
            localStorage.setItem("userSession", JSON.stringify(userSession));
        },

        setCommunityUser(userCommunity: UserCommunity) {
            this.userCommunity = userCommunity
            localStorage.setItem("userCommunity", JSON.stringify(userCommunity));
        },
        setBlockUser(userBlock: UserBlock) {
            this.userBlock = userBlock
            localStorage.setItem("userBlock", JSON.stringify(userBlock));
        },

        logout() {
            this.token = null
            this.user = null
            localStorage.removeItem("userId")
            localStorage.removeItem("token")
            localStorage.removeItem("user")
            localStorage.removeItem("userSession")
            localStorage.removeItem("userCommunity")
            localStorage.removeItem("userBlock")
        }
    },

    getters: {
        userIsAuthenticated(state): boolean {
            return state.user != null
        }
    }
})

export type AuthStore = ReturnType<typeof useAuthStore>
